var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonFailedIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0466 0H13.3438V112H98.6562V21.6097L77.0466 0ZM78.9688 11.2028L87.4534 19.6875H78.9688V11.2028ZM19.9062 105.438V6.5625H72.4062V26.25H92.0938V105.438H19.9062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9533 58.7181L45.5936 54.0778L40.9533 49.4374L45.5936 44.7971L40.9533 40.1567L36.3129 44.7971L31.6726 40.1567L27.0322 44.7971L31.6726 49.4374L27.0322 54.0778L31.6726 58.7181L36.3129 54.0778L40.9533 58.7181Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3283 40.1567L75.6879 44.7971L71.0476 40.1567L66.4072 44.7971L71.0476 49.4374L66.4072 54.0778L71.0476 58.7181L75.6879 54.0778L80.3283 58.7181L84.9686 54.0778L80.3283 49.4374L84.9686 44.7971L80.3283 40.1567Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 65.8438C43.335 65.8438 33.0312 76.1475 33.0312 88.8125V92.0938H39.5938V88.8125C39.5938 79.7661 46.9536 72.4062 56 72.4062C65.0464 72.4062 72.4062 79.7661 72.4062 88.8125V92.0938H78.9688V88.8125C78.9688 76.1475 68.665 65.8438 56 65.8438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonFailedIc);
export default __webpack_public_path__ + "static/media/lesson_failed_ic.ebbdd0a5d3311e73cc115b7d635f4250.svg";
export { ForwardRef as ReactComponent };